<template>
  <form ref="form" @submit.prevent="handleSubmit">
    <v-container fluid class="main">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Transfer Method ( <span style="color: #039DE9;">Automatic *</span> )</legend>
                  <v-text-field label="Crypto Transfer" disabled placeholder="Crypto Transfer" single-line solo
                    hide-details readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Crypto Network</legend>
                  <v-text-field :label="this.ovypaycrypto?.network" disabled :placeholder="this.ovypaycrypto?.network"
                    single-line solo hide-details readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange">
                  </v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field v-model="depositAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select" min="1" :rules="[rules.required, rules.minAmount]"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn type="submit" tile elevation="0" class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain" :loading="loading" :disabled="!isFormValid || loading || selectedNetworkAddress">
                  Generate QR
                </v-btn>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="crypto-div">
                <v-card-title class="title px-0 py-0">Instructions:</v-card-title>

                <ol class="instruction">
                  <li>
                    Please scan the QR code or copy the wallet address shown to make your deposit.
                  </li>
                  <li>
                    Only send <strong>USDT (TRC20)</strong> to this address. Sending any other token or network may
                    result in a permanent loss of funds.
                  </li>
                  <li>
                    The wallet address is valid for <strong>5 minutes</strong>. Make sure to complete your transfer
                    before it expires.
                  </li>
                  <li>
                    Transfers from <strong>third-party wallets</strong> or exchanges are not accepted. The sender’s name
                    must match the registered account holder’s name.
                  </li>
                  <li>
                    Network fees are charged by the blockchain. Ensure the exact deposit amount (excluding network fee)
                    reaches the address.
                  </li>
                  <li>
                    Once payment is completed, the system will automatically verify your transaction. You don’t need to
                    submit a receipt.
                  </li>
                  <li>
                    If your deposit does not appear after confirmation, please contact support with your
                    <strong>transaction ID (TXID)</strong>.
                  </li>
                </ol>
              </v-col>

            </v-row>
          </v-card>
        </v-col>

        <v-col v-if="selectedNetworkAddress" xl="6" lg="5" md="5" sm="5" cols="12">
          <v-card class="elevation-0 rounded-0 mt-2" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">

            <div class="counter">
              {{ formattedTime }}
            </div>

            <v-card-text class="content">
              <h3 class="mb-2">Broker <strong class="colormain">Crypto</strong> Address</h3>
              <span class="d-inline-block text-truncate" ref="addressText">{{ selectedNetworkAddress }}</span>
              <v-btn tile elevation="0" class="ma-0 text-capitalize btn-account d-block mx-auto" color="greenMain" small
                @click="copyAddress">
                {{ copied ? 'Copied!' : 'Copy Address' }}
              </v-btn>
            </v-card-text>

            <v-card-text class="content">
              <v-img :src="qrCodeUrl || null" class="mx-auto" alt="QR Code" width="260" height="auto">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card-text>

            <v-card-text class="content waiting mt-3" v-if="selectedNetworkAddress">
              <v-progress-circular indeterminate color="grey lighten-5" class="mr-1" size="20"></v-progress-circular>
              Waiting for transaction confirmation...
            </v-card-text>

          </v-card>
        </v-col>
        <v-col v-else xl="6" lg="5" md="5" sm="5" cols="12">
          <v-card class="crypto-text elevation-0 rounded-0 mt-2" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-text v-if="!formattedTime">
              QR code and wallet address will appear here.
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CRYPTO__ACTIONS, DEPOSITMETHODS__ACTIONS, PROFILE__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";
import axios from "axios";

export default {
  name: 'CryptoDepositForm',

  data() {
    return {
      payment_id: null,
      selectedAccount: null,

      selectedNetworkAddress: null,
      formattedTime: null,
      expires_in: null,

      count: 0,
      orderId: null,


      selectedNetwork: 'Trc20-OvyPay',
      depositAmount: '',
      currencyAmount: '',
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#fff"
      },
      bankSlip: null,
      loading: false,
      copied: false,
      baseUrl: 'https://api.qrserver.com/v1/create-qr-code/',
      rules: {
        required: value => !!value || 'This field is required',
        minAmount: value => value > 0 || 'Amount must be greater than 0'
      }
    };
  },

  computed: {
    ...mapState("crypto", ["ovypaycrypto"]),
    ...mapState("deposit", ["accounts", "needSlip"]),
    ...mapState("profile", ["client"]),

    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },

    qrCodeUrl() {
      return this.selectedNetworkAddress
        ? `${this.baseUrl}?size=200x200&data=${encodeURIComponent(this.selectedNetworkAddress)}`
        : null;
    },

    isFormValid() {
      return this.selectedAccount &&
        this.selectedNetwork &&
        this.depositAmount > 0
    },
  },

  watch: {
    depositAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("crypto", [CRYPTO__ACTIONS.OVYPAY]),
    ...mapActions("profile", [PROFILE__ACTIONS.GETPROFILE]),
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAY,
      DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION,
      DEPOSITMETHODS__ACTIONS.PAYMENTLOG,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
      DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAYQR,
      DEPOSITMETHODS__ACTIONS.CHECKCRYPTODEPOSITOVIPAY,
    ]),

    startCountdown() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      const endTime = Date.now() + this.expires_in;
      this.timerInterval = setInterval(() => {
        const remainingMs = endTime - Date.now();

        if (remainingMs > 0) {
          const secondsLeft = Math.floor(remainingMs / 1000);
          this.formattedTime = this.formatTime(secondsLeft);
        } else {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
          this.formattedTime = "Expired";
          this.selectedNetworkAddress = null;
          this.qrCodeUrl = null;
          toast.error("QR expired. Please regenerate.");
        }
      }, 1000);
    },

    formatTime(seconds) {
      const min = Math.floor(seconds / 60);
      const sec = seconds % 60;
      return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    },


    handleAccountChange() {
      this.depositAmount = '';
      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      this.currencyAmount = '';
      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    async copyAddress() {
      if (!this.selectedNetworkAddress) return;

      try {
        await navigator.clipboard.writeText(this.selectedNetworkAddress);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (err) {
        console.log('Failed to copy:', err);
      }
    },

    validateForm() {
      if (!this.depositAmount || this.depositAmount <= 0) {
        toast.error('Please enter a valid deposit amount');
      }
    },

    // async handleSubmit() {
    //   try {
    //     this.validateForm();
    //     this.loading = true;
    //     this.orderId = `OvyPay-Crypto-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;

    //     const { data: res } = await axios.post('https://tron.ovypay.com/api/create-payment',
    //       {
    //         amount: parseFloat(this.depositAmount),
    //         orderId: this.orderId,
    //         receiverWallet: this.ovypaycrypto?.address || "na",
    //         description: `${this.client?.fname} ${this.client?.lname}_${this.client?.id}`,
    //         callbackUrl: "https://tron.ovypay.com/api/payment/check-payment",
    //         customerEmail: this.client?.email,
    //         merchantName: "GICM-OvyPay",
    //         productInfo: "Crypto-Deposit-OvyPay",
    //       },
    //       {
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'X-API-Key': 'ovypay_api_9bN4kR2qW8tY3vM6cX1zL7pF0dJ5hG8sK3nB6vT9qY2wU5iR8mO1jH4fC7aZ0',
    //         },
    //       }
    //     );

    //     console.log("OvyPay Response QR", res)

    //     if (res.success == true && res.paymentDetails.orderId == this.orderId) {
    //       //this.expires_in = res.expires_in;
    //       this.expires_in = 60000 * 30; // 5 minutes in milliseconds
    //       this.formattedTime = this.formatTime(this.expires_in / 1000);

    //       const cryptoAddress = res.paymentDetails.receiverWallet;
    //       this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(res.paymentDetails.qrCodeData)}`;

    //       this.selectedNetworkAddress = cryptoAddress;
    //       this.startCountdown();

    //       await this[DEPOSITMETHODS__ACTIONS.PAYMENTLOG]({
    //         res: res,
    //         payment_type: 'OvyPay-Crypto',
    //         gateway: 'OvyPay',
    //         payment_system_id: this.payment_id,
    //         amount: this.depositAmount,
    //         wallet_address: cryptoAddress,
    //         trading_account_no: this.selectedAccount,
    //         transactionId: this.orderId,
    //       });

    //       // 2️⃣ Begin polling for transaction confirmation
    //       await this.pollTransactionStatus(cryptoAddress, this.depositAmount, this.expires_in, res.paymentDetails.orderId);

    //     } else {
    //       toast.error("Failed to generate deposit address. Please try again.");
    //     }
    //   } catch (error) {
    //     console.log("Deposit submission error:", error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    // async pollTransactionStatus(walletAddress, amount, timeoutMs, orderId) {
    //   const intervalMs = 5000;
    //   const endTime = Date.now() + timeoutMs;
    //   let txRes = null;
    //   let stopPolling = false;

    //   const poll = async () => {
    //     const now = Date.now();
    //     if (now >= endTime || stopPolling) {
    //       console.log("⏰ Polling stopped — expired or success");
    //       return;
    //     }

    //     try {
    //       const { data } = await axios.get(`https://tron.ovypay.com/api/check-payment?orderId=${orderId}`);
    //       txRes = data;

    //       console.log("Callback Response:", txRes);

    //       // Call notification action once at start
    //       if (txRes && this.count === 0) {
    //         this.count++;
    //         await this[DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION](txRes);
    //       }

    //       if (txRes?.success == true && txRes.paymentDetails?.orderId === orderId && txRes.paymentDetails?.status === "confirmed") {

    //         stopPolling = true; 

    //         const formData = new FormData();
    //         formData.append('trading_account_no', this.selectedAccount);
    //         formData.append('amount', amount);
    //         formData.append('network', 'Trc20-OvyPay');
    //         formData.append('payment_id', this.payment_id);
    //         formData.append('wallet_address_broker', walletAddress);
    //         formData.append('wallet_address_client', txRes.paymentDetails?.paymentId || 'No-payment-id-found');
    //         formData.append('transactionId', txRes.paymentDetails?.orderId || orderId);
    //         formData.append('cryptoWalletStatus', txRes.paymentDetails?.status || 'No-status-found');

    //         console.log("Finalizing deposit with data:", formData);

    //         await this[DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAY](formData);

    //         // Cleanup UI
    //         this.qrCodeUrl = "";
    //         this.timerInterval = null;
    //         this.resetForm();

    //         return; 
    //       } else {
    //         console.log("Waiting for confirmation...");
    //       }
    //     } catch (err) {
    //       console.log("Polling error:", err);
    //     }

    //     //Keep polling if not stopped yet
    //     if (!stopPolling) {
    //       setTimeout(poll, intervalMs);
    //     }
    //   };

    //   await poll();
    // },

    async handleSubmit() {
      try {
        this.validateForm();
        this.loading = true;
        this.orderId = `OvyPay-Crypto-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;

        // Prepare payload for backend proxy
        const payload = {
          amount: parseFloat(this.depositAmount),
          orderId: this.orderId,
          receiverWallet: this.ovypaycrypto?.address || "na",
          description: `${this.client?.fname} ${this.client?.lname}_${this.client?.id}`,
          callbackUrl: "https://tron.ovypay.com/api/payment/check-payment",
          customerEmail: this.client?.email,
          merchantName: "GICM-OvyPay",
          productInfo: "Crypto-Deposit-OvyPay",
        };

        // ✅ Call backend proxy via Vuex action
        const res = await this[DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAYQR](payload);
        
        console.log("OvyPay Response QR", res);

        if (res.success && res.paymentDetails?.orderId === this.orderId) {
          this.expires_in = 30 * 60 * 1000; // 30 mins
          this.formattedTime = this.formatTime(this.expires_in / 1000);

          const cryptoAddress = res.paymentDetails.receiverWallet;
          this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(res.paymentDetails.qrCodeData)}`;
          this.selectedNetworkAddress = cryptoAddress;

          this.startCountdown();

          // Log payment creation
          await this[DEPOSITMETHODS__ACTIONS.PAYMENTLOG]({
            res,
            payment_type: 'OvyPay-Crypto',
            gateway: 'OvyPay',
            payment_system_id: this.payment_id,
            amount: this.depositAmount,
            wallet_address: cryptoAddress,
            trading_account_no: this.selectedAccount,
            transactionId: this.orderId,
          });

          // ✅ Start polling for confirmation via backend proxy
          await this.pollTransactionStatus(
            cryptoAddress,
            this.depositAmount,
            this.expires_in,
            res.paymentDetails.orderId
          );
        } else {
          toast.error("Failed to generate deposit address. Please try again.");
        }
      } catch (error) {
        console.log("Deposit submission error:", error);
        toast.error("Error generating payment session. Please try again later.");
      } finally {
        this.loading = false;
      }
    },

    async pollTransactionStatus(walletAddress, amount, timeoutMs, orderId) {
      const intervalMs = 5000;
      const endTime = Date.now() + timeoutMs;
      let stopPolling = false;

      const poll = async () => {
        const now = Date.now();
        if (now >= endTime || stopPolling) return;

        try {
          // ✅ Use Vuex action to hit backend proxy for status
          const txRes = await this[DEPOSITMETHODS__ACTIONS.CHECKCRYPTODEPOSITOVIPAY](orderId);

          console.log("Payment check response:", txRes);

          if (txRes.success && txRes.paymentDetails?.status === "success") {
            stopPolling = true;
            toast.success("Transaction confirmed!");

            const formData = new FormData();
            formData.append("trading_account_no", this.selectedAccount);
            formData.append("amount", amount);
            formData.append("network", "Trc20-OvyPay");
            formData.append("payment_id", this.payment_id);
            formData.append("wallet_address_broker", walletAddress);
            formData.append("wallet_address_client", txRes.paymentDetails.receiverWallet);
            formData.append("transactionId", txRes.paymentDetails.paymentId);
            formData.append("cryptoWalletStatus", txRes.paymentDetails.status);


            console.log("Inside success-", formData )
            // ✅ Log confirmed payment
            await this[DEPOSITMETHODS__ACTIONS.PAYMENTNOTIFICATION](txRes);

            // ✅ Finalize deposit creation
            await this[DEPOSITMETHODS__ACTIONS.CREATECRYPTODEPOSITOVIPAY](formData);

            // Cleanup UI
            this.qrCodeUrl = "";
            this.selectedNetworkAddress = null;
            if (this.timerInterval) clearInterval(this.timerInterval);
            this.resetForm();
            return;
          } else {
            console.log("Waiting for confirmation...");
          }
        } catch (err) {
          console.log("Polling error:", err.message);
        }

        if (!stopPolling) setTimeout(poll, intervalMs);
      };

      await poll();
    },


    resetForm() {
      this.$nextTick(() => {
        this.depositAmount = '';
        this.bankSlip = null;
        this.copied = false;
        this.count = 0;
        this.oderId = null;
        this.expires_in = null;

        if (this.$refs.form) {
          this.$refs.form.reset();
        }

        const fileInput = this.$refs.fileInput;
        if (fileInput) {
          fileInput.reset();
        }
      });
    }
  },

  async mounted() {
    try {
      this.payment_id = this.$route.query.payment_id;
      await Promise.all([
        this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]()
      ]);
    } catch (error) {
      console.log('Failed to fetch initial data:', error);
    }
  },

  async created() {
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();
    await this[CRYPTO__ACTIONS.OVYPAY]();
    await this[PROFILE__ACTIONS.GETPROFILE]();
  }
};
</script>

<style>
.content {
  text-align: center;
}

.crypto-form-card {
  height: 420px;
  position: relative;
  ;
}

.counter {
  position: absolute;
  top: 10px;
  left: 10px;
  text-align: center;
  color: rgb(206, 9, 36);
  font-size: 20px;
  font-weight: 700;
}

.main {
  height: 100vh !important;
  overflow-y: scroll;
  margin: 0;
}

.waiting {
  text-align: center;
  width: 100%;
}

.crypto-div {
  min-height: 380px;
}

.crypto-text {
  min-height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
}

.colormain {
  color: #039DE9;
}
</style>